import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-950 border-t border-gray-900 py-12">
      <div className="container mx-auto px-4 text-center">
        <img src="/assets/logo.png" alt="TOP CAR" className="h-10 mx-auto mb-6" />
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 text-gray-400 mb-8">
          <div className="flex items-center gap-2"><MapPin size={18} className="text-orange-500"/> Socimat, Kinshasa</div>
          <div className="flex items-center gap-2"><Phone size={18} className="text-orange-500"/> +243 828 706 717</div>
          <div className="flex items-center gap-2"><Mail size={18} className="text-orange-500"/> contact@topcar.cd</div>
        </div>
        <p className="text-sm text-gray-600">&copy; 2026 TOP CAR. Tous droits réservés.</p>
      </div>
    </footer>
  );
};
export default Footer;
